import { render, staticRenderFns } from "./AchPayment.vue?vue&type=template&id=096f5870&scoped=true"
import script from "./AchPayment.vue?vue&type=script&lang=js"
export * from "./AchPayment.vue?vue&type=script&lang=js"
import style0 from "./AchPayment.vue?vue&type=style&index=0&id=096f5870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f5870",
  null
  
)

export default component.exports